import React from 'react';
import './Podcast.css';

const Podcast = () => {
  return (
    <div className="podcast-page">
      <div className="podcast-container">
        <h1>播客</h1>
        <div className="podcast-content">
          <p>这里是我的播客列表。</p>
          {/* 播客列表会在这里展示 */}
        </div>
      </div>
    </div>
  );
};

export default Podcast; 